enum FeedbackRequestType {
  "pages.masterdata.activities.text" = 0,
  "pages.masterdata.activities.number" = 1,
  "pages.masterdata.activities.single_select_pick_list" = 2,
  "pages.masterdata.activities.slider" = 3,
}

export default FeedbackRequestType;
